
import './Footer.css'

function Footer() {
    return (
        <footer>
            <div className="content">
            &copy; 2025 Nanjing Miraitsu Software Technology Co., Ltd. All Rights Reserved.
            </div>
            <div className="content" style={{display: 'flex', alignItems: 'center'}}>
                <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">苏ICP备2025157621号</a>
                
                <div style={{marginLeft: '5px'}}></div>

                <img src='images/gaba.png' width="16px" height="16px" alt="备案" />
                <span style={{marginLeft: '5px'}}><a href="https://beian.mps.gov.cn/#/query/webSearch?code=32011402012123" rel="noreferrer" target="_blank">苏公网安备32011402012123号</a></span>
            </div>
        </footer>
    );
}

export default Footer;